import styled from 'styled-components';

const TypeformContainer = styled.div`
  position: relative;
  width: 110%;
  margin-left: -2rem;
  margin-top: -1rem;
  min-height: 45rem;

  iframe {
    min-height: 45rem;
  }
`;

export { TypeformContainer };
